<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/G4MWbq/images/Cover.jpg?1735274501427" alt="This image is the cover for the book Haunted Staten Island, Haunted America"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Haunted Staten Island, Haunted America
      </h1>
      <p class="bookDescription body article font2">
        <p>Marianna Randazzo reveals terrifying legends, historical accounts and firsthand testimonies, offering readers a thrilling journey into the dark underbelly of Staten Island's haunted past. <br/> Staten Island is known as the mystifying borough, and it is home to numerous ghosts and eerie tales. The Alice Austin House was once home to a pioneering photographer, but ghostly images of a different sort now appear among the beams. The Moravian Cemetery in New Dorp holds tales of supernatural echoes, while over at the Old Bermuda Inn, the specter of Martha Mersereau, waiting for the return of her dead husband, appears at candlelit windows each evening. On some of the island's most desolate roads, a spectral hitchhiker appears, vanishing from the car mid-ride, leaving only an eerie chill. Countless travelers have encountered her, a haunting reminder of the thin line between the living and the dead. Local author Marianna Randazzo uncovers the secrets behind Staten Island's haunted houses, spectral sightings and enduring legends.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Marianna Biazzo Randazzo
      </h2>
      
      <p class="authorDescription body article">Marianna Randazzo, an author with a rich background, blends her experiences growing up in Brooklyn, New York, and her nearly two decades as a Staten Islander. Marianna has received literary awards for her work, such as the OSDIA Literary Award, the Morgagni Society Silver Medal Award and the Garibaldi-Meucci Museum Recognition Award. Marianna has written Given Away: A Sicilian Upbringing (10 th anniversary edition), Italians of Brooklyn (Arcadia Publishing, 2018), Father Vincent R. Capodanno, Navy Chaplain and Michael Behette: Brooklyn's Best , as well as hundreds of parenting and educational articles for publications over the years. To learn more about her work, visit her website at www.marianna-Randazzo.com.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The History Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?740643a7